<script lang="ts">
  import LogoLinkText from "./LogoLinkText.svelte";
  import CredenzaLogo from "../../../images/credenza.svg";

  export let additionalLogo: { img?: string, width: number} | undefined = undefined;
</script>

<section class="crtw-flex crtw-flex-col crtw-items-center crtw-pt-11">
  <div class="crtw-flex crtw-items-center crtw-justify-center crtw-gap-4">
    <img
      src={CredenzaLogo}
      alt="credenza-logo"
      class="crtw-w-[110px]"
    />
    {#if additionalLogo?.img}
      <img
        src={additionalLogo?.img}
        alt="additional-logo"
        style={`width: ${additionalLogo?.width}px`}
      />
    {/if}
  </div>
  
  <div
    class="crtw-text-center crtw-text-textMain crtw-text-xs crtw-flex crtw-justify-center
    crtw-items-center crtw-pt-[3px] sm:crtw-pt-2"
  >
    <a
      class="crtw-text-hightlightColor crtw-no-underline crtw-mr-1.5 crtw-text-[10px]"
      href="https://www.credenza3.com"
      target="_blank"
      rel="noreferrer">Credenza</a
    >
    <LogoLinkText>·</LogoLinkText>
    <LogoLinkText
      ><a
        class="crtw-text-hightlightColor crtw-no-underline"
        href="https://www.credenza3.com/company/about"
        target="_blank"
        rel="noreferrer">About</a
      ></LogoLinkText
    >

    <LogoLinkText>·</LogoLinkText>
    <LogoLinkText
      ><a
        class="crtw-text-hightlightColor crtw-no-underline"
        href="mailto:info@credenza3.com"
      >
        Contact</a
      ></LogoLinkText
    >
    <LogoLinkText>·</LogoLinkText>
    <LogoLinkText
      ><a
        class="crtw-text-hightlightColor crtw-no-underline"
        href="https://www.credenza3.com/privacy-policy"
        target="_blank"
        rel="noreferrer">Privacy & terms</a
      ></LogoLinkText
    >
  </div>
</section>
